import { render, staticRenderFns } from "./searchContent.vue?vue&type=template&id=1497f2ce&scoped=true&"
import script from "./searchContent.vue?vue&type=script&lang=js&"
export * from "./searchContent.vue?vue&type=script&lang=js&"
import style0 from "./searchContent.vue?vue&type=style&index=0&id=1497f2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497f2ce",
  null
  
)

export default component.exports